//import ENV from "@/util/env";

const API_URL = "https://calculadoraapi.crediamigo.fin.ec/";

export default API_URL;
